import * as React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import PropTypes from 'prop-types'
import { SITE_HEADER_ID, SITE_FOOTER_ID } from 'utils/constants'
import ContentBlock from 'blocks/Content/Content'
import Newsletter from 'containers/Newsletter'
import RouterLink from 'containers/RouterLink'
import BrandIcon from 'components/icons/Brand'
import InstagramIcon from 'components/icons/Instagram'
import Container from 'components/Container'
import AppBar from 'components/AppBar'
import Toolbar from 'components/Toolbar'
import IconButton from 'components/IconButton'

const BREAKPOINT_KEY_UP = 'md'

export const useStyles = makeStyles((theme) => ({
  '@global': {
    [`#${SITE_HEADER_ID}, #${SITE_FOOTER_ID}`]: {
      display: 'none',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  header: {},
  menuToolbar: {
    justifyContent: 'center',
  },
  brandIcon: {
    width: 'auto',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: 1,
    outline: 0, // Disable focus ring as `main` is focusable via "Skip Link".
    [theme.breakpoints.up(BREAKPOINT_KEY_UP)]: {
      paddingRight: '20%',
    },
  },
  newsletterContainer: {
    marginBottom: 'var(--coa-section-spacing)',
  },
  newsletter: theme.mixins.contain('var(--coa-content-max-width)'),
  footer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  footerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  share: {
    display: 'flex',
    alignItems: 'center',
  },
  shareLabel: {
    ...theme.typography.overline,
    marginRight: theme.spacing(1),
  },
}))

function Maintenance(props) {
  const { content, hideNewsletter, hideNewsletterText } = props
  const classes = useStyles(props)

  const brandButton = (
    <IconButton
      className={classes.brandButton}
      component={RouterLink}
      href="/"
      aria-label="Go to the homepage"
    >
      <BrandIcon className={classes.brandIcon} />
    </IconButton>
  )

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar className={classes.menuToolbar}>{brandButton}</Toolbar>
      </AppBar>

      <div className={classes.main}>
        <ContentBlock content={content} />

        {!hideNewsletter && (
          <Container className={classes.newsletterContainer} maxWidth={false}>
            <Newsletter className={classes.newsletter} toggleNewsletterText={hideNewsletterText} />
          </Container>
        )}
      </div>

      <footer className={classes.footer}>
        <Container className={classes.footerContainer} maxWidth={false}>
          <div className={classes.share}>
            <span className={classes.shareLabel}>Follow KÄLLA</span>

            <IconButton
              href="https://www.instagram.com/kalla_official/"
              size="small"
              title="Visit us on Instagram"
            >
              <InstagramIcon />
            </IconButton>
          </div>

          {React.cloneElement(brandButton, { edge: 'end' })}
        </Container>
      </footer>
    </div>
  )
}

Maintenance.propTypes = {
  content: PropTypes.string.isRequired,
  hideNewsletter: PropTypes.bool,
  hideNewsletterText: PropTypes.bool,
}

export default Maintenance
